import Vue from 'vue'
import EventBus from '../_event-bus'
import { $ } from '../_utils'

const BREAKPOINT = 768

Vue.component('vue-prize-controls', {
  template: '#vue-prize-controls-template',
  data() {
    return {
      isMobile: false,
    }
  },
  methods: {
    setLayout,
    subscribeToResizeListener,
  },
  mounted() {
    this.subscribeToResizeListener()
    this.setLayout(window.innerWidth)
  },
})

function setLayout(viewporWidth) {
  this.isMobile = viewporWidth < BREAKPOINT
}

function subscribeToResizeListener() {
  EventBus.$on('resize', this.setLayout)
}

const el = $('#vue-prize-controls-wrapper')
if (el) window.addEventListener('DOMContentLoaded', () => new Vue({ el }))
